
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Auth_Failure_List from "./Auth_Failure_List";

const Auth_Failures_Dist = ({ month, year }) => {
    const [data, setData] = useState([]);
    const [totals, setTotals] = useState({});
    const [refreshTime, setRefreshTime] = useState("");
    const [selectedError, setSelectedError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const fetchOnce = useRef(false);

    useEffect(() => {
        if (!month || !year || fetchOnce.current) return;

        fetchOnce.current = true;
        setLoading(true);

        const fetchData = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_URL_HEADER}/api/authFailures/dist_auth_failures`,
                    {
                        params: { month, year },
                        withCredentials: true,
                    }
                );

                setIsLoggedIn(res.data.user_role !== null);
                setData(res.data.list || []);
                setRefreshTime(res.data.refresh_time || "");

                setTotals({
                    tot_300: res.data.tot_300,
                    tot_330: res.data.tot_330,
                    tot_800: res.data.tot_800,
                    tot_810: res.data.tot_810,
                    tot_811: res.data.tot_811,
                    tot_996: res.data.tot_996,
                    tot_997: res.data.tot_997,
                    tot_998: res.data.tot_998,
                    tot_oth: res.data.tot_oth,
                    tot_auth: res.data.tot_auth,
                    tot_genuine: res.data.tot_genuine,
                });
            } catch (err) {
                console.error("Error fetching data:", err);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [month, year]);

    const handleClick = (dist_code, code) => {
        if (!isLoggedIn) return;
        setSelectedError({ errorCode: code, distCode: dist_code });
    };

    if (!data || data.length === 0) {
        return (
            <div style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
                Details Not Found
            </div>
        );
    }

    return (
        <div>
            {loading && <div style={{ textAlign: "center" }}>Loading...</div>}
            <table
                border="1"
                width="90%"
                style={{ margin: "auto", borderCollapse: "collapse" }}
            >
                <thead>
                    <tr className="tableheader">
                        <th rowSpan="2">Sl No</th>
                        <th rowSpan="2">District</th>
                        <th rowSpan="2">Genuine<br />Failures</th>
                        <th colSpan="9">Error Codes Abstract</th>
                        <th rowSpan="2">Total</th>
                    </tr>
                    <tr className="tableheader">
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>300</span><br />(Biometric not matched)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>330</span><br />(Biometric locked)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>800</span><br />(Invalid Biometric)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>810</span><br />(Missing Biometric data)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>811</span><br />(Service not available)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>996</span><br />(Aadhaar not found)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>997</span><br />(Invalid Aadhaar Status)</th>
                        <th><span style={{ color: 'orange', fontWeight: 'bold' }}>998</span><br />(Technical error)</th>
                        <th>Others</th>
                    </tr>
                </thead>

                <tbody>
                    {data.map((item, index) => (
                        <tr key={item.dist_code}>
                            <td>{index + 1}</td>
                            <td>{item.dist_name}</td>
                            <td>
                                {isLoggedIn && item.genuine > 0 ? (
                                    <a onClick={() => handleClick(item.dist_code, "100")} style={{ cursor: "pointer", color: "black" }}>
                                        {item.genuine}
                                    </a>
                                ) : item.genuine}
                            </td>

                            {[
                                { key: "aadhar_300", code: "300" },
                                { key: "aadhar_330", code: "330" },
                                { key: "aadhar_800", code: "800" },
                                { key: "aadhar_810", code: "810" },
                                { key: "aadhar_811", code: "811" },
                                { key: "aadhar_996", code: "996" },
                                { key: "aadhar_997", code: "997" },
                                { key: "aadhar_998", code: "998" },
                                { key: "aadhar_others", code: "000" },
                            ].map(col => (
                                <td key={col.code}>
                                    {isLoggedIn && item[col.key] > 0 ? (
                                        <a onClick={() => handleClick(item.dist_code, col.code)} style={{ cursor: "pointer", color: "black" }}>
                                            {item[col.key]}
                                        </a>
                                    ) : item[col.key]}
                                </td>
                            ))}

                            <td>{item.aadhar_total}</td>
                        </tr>
                    ))}

                    <tr className="tableheader">
                        <th colSpan="2">Total</th>
                        <th align="right">{totals.tot_genuine}</th>
                        <th align="right">{totals.tot_300}</th>
                        <th align="right">{totals.tot_330}</th>
                        <th align="right">{totals.tot_800}</th>
                        <th align="right">{totals.tot_810}</th>
                        <th align="right">{totals.tot_811}</th>
                        <th align="right">{totals.tot_996}</th>
                        <th align="right">{totals.tot_997}</th>
                        <th align="right">{totals.tot_998}</th>
                        <th align="right">{totals.tot_oth}</th>
                        <th align="right">{totals.tot_auth}</th>
                    </tr>

                    <tr align="right">
                        <td colSpan="13">
                            <b style={{ color: "red" }}>Last Refreshed:-</b>{" "}
                            <span style={{ color: "green" }}>{refreshTime}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            {selectedError && (
                <Auth_Failure_List
                    errorCode={selectedError.errorCode}
                    month={month}
                    year={year}
                    distCode={selectedError.distCode}
                    onClose={() => setSelectedError(null)}
                />
            )}
        </div>
    );
};

export default Auth_Failures_Dist;
